// Lightweight consent gate for client-side analytics (Mixpanel). Tracking is
// opt-in: nothing fires until a partner explicitly accepts via
// AnalyticsConsentBanner, and browser Do Not Track is always honored.
const CONSENT_KEY = "cta_pad_analytics_consent";
const listeners = new Set();

function isDoNotTrackEnabled() {
  if (typeof navigator === "undefined") return false;
  const dnt = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
  return dnt === "1" || dnt === "yes";
}

export function getAnalyticsConsent() {
  if (isDoNotTrackEnabled()) return false;

  try {
    const stored = window.localStorage.getItem(CONSENT_KEY);
    if (stored === "granted") return true;
    if (stored === "declined") return false;
  } catch {
    // localStorage unavailable (private browsing, etc.) - treat as undecided
  }
  return null;
}

export function hasAnalyticsConsent() {
  return getAnalyticsConsent() === true;
}

export function setAnalyticsConsent(granted) {
  try {
    window.localStorage.setItem(CONSENT_KEY, granted ? "granted" : "declined");
  } catch {
    // ignore write failures; listeners still fire for this session
  }
  listeners.forEach((listener) => listener(granted));
}

export function onAnalyticsConsentChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
